"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSelector = void 0;
const react_1 = __importStar(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const util_1 = require("../../../util");
const Badge_1 = __importDefault(require("../Badge/Badge"));
const hooks_1 = require("../../../util/hooks");
const Grid_1 = __importDefault(require("../../layout/Grid/Grid"));
const TagSelector = (prop) => {
    const { items, onChange, placeholder, disabled, autoFocus, value } = prop;
    const [focus, setFocus] = (0, react_1.useState)(autoFocus || false);
    const [selected, setSelected] = (0, react_1.useState)(value?.map((val) => {
        return items?.find((e) => e.key === val) || { key: val, text: val };
    }));
    const [text, setText] = (0, react_1.useState)('');
    const ref = (0, hooks_1.useAutoClose)(() => {
        setFocus(false);
    }, !focus);
    const fItems = (0, react_1.useMemo)(() => {
        return (items?.filter((s) => (s.text?.toLowerCase().includes(text.toLowerCase()) ||
            s.key?.toLowerCase().includes(text.toLowerCase())) &&
            !selected.find((e) => e.key === s.key)) || []);
    }, [items, text, selected]);
    const setNew = (0, react_1.useCallback)((e) => {
        setText('');
        const cur = [...selected, e];
        setSelected(cur);
        onChange?.(cur.map((x) => x.key), { mode: 'NEW', id: e.key });
    }, [onChange, selected]);
    return (react_1.default.createElement("div", { ref: ref, className: (0, util_1.cnx)(`glx-tag-selector`) },
        react_1.default.createElement("div", { className: (0, util_1.cnx)('glx-flex', 'glx-flex-row', 'glx-pb-8', 'glx-flex-wrap', 'glx-flex-g-8') }, selected.map((e) => (react_1.default.createElement(Badge_1.default, { key: e.key, text: e.text, icon: e.icon, color: e.color, close: () => {
                const cur = selected.filter((x) => x.key !== e.key);
                onChange?.(cur.map((x) => x.key), { mode: 'DEL', id: e.key });
                setSelected(cur);
            } })))),
        react_1.default.createElement("input", { type: "text", value: text, onFocus: () => setFocus(true), autoFocus: autoFocus, placeholder: placeholder, disabled: disabled, onKeyUpCapture: (event) => {
                if (event.key === 'Enter') {
                    if (fItems.length >= 1) {
                        setNew(fItems[0]);
                    }
                }
                else if (event.key === 'Escape' && focus) {
                    setFocus(false);
                }
            }, onChange: (e) => {
                setText(e.target.value);
            } }),
        focus && fItems.length > 0 ? (react_1.default.createElement(Grid_1.default, { flex: true, flexC: true, className: "glx-tag-selector--drawer", gap: 6 }, fItems?.map((e) => (react_1.default.createElement(Grid_1.default, { key: e.key, flex: true, flexR: true, gap: 12, onClick: () => setNew(e), vCenter: true },
            react_1.default.createElement("div", { style: {
                    color: e.color || undefined,
                } }, e.icon
                ? (0, react_icons_1.getIcon)(e.icon)({
                    size: 20,
                })
                : null),
            react_1.default.createElement("div", null, e.text || e.key)))))) : null));
};
exports.TagSelector = TagSelector;
exports.TagSelector.defaultProps = {
    items: undefined,
    onChange: undefined,
    placeholder: undefined,
    disabled: undefined,
    autoFocus: undefined,
};
